<template>
        <header class="reader-site-header header">
                <div class="header-layout">
                        <div class="brand">
                                <div class="brand-logo" role="img" aria-label="АСТ-Пресс Школа"></div>
                                <div class="brand-text">
                                        <div class="brand-title">АСТ-ПРЕСС ШКОЛА</div>
                                        <div class="brand-subtitle">Электронные учебники</div>
                                </div>
                        </div>

                        <div v-if="showUserAvatar || $slots.actions" class="header-actions">
                                <slot name="actions" />
                                <ReaderUserMenu v-if="showUserAvatar" />
                        </div>
                </div>
        </header>
</template>

<script setup lang="ts">
        import ReaderUserMenu from "@/window/ReaderUserMenu.vue"

        withDefaults(defineProps<{ showUserAvatar?: boolean }>(), { showUserAvatar: true })
</script>
